module.exports = __webpack_public_path__ + "img/desktop-arrow-down.53469517.svg";